import { createFileRoute } from '@tanstack/react-router'
import { AutomationsView } from '../../../modules/automations/automations-view'

export const Route = createFileRoute('/_authed/automations/')({
  component: AutomationsView,
})
